import type { ApiResponse } from '@abaninja/types';

import { httpClient } from '@abaninja/util-http-client';
import { createCancellablePromise } from '@abaninja/util-store';

import type { Sender } from '../@types/sender';

export function getSenderDetails() {
  return createCancellablePromise(
    ({ signal }) => httpClient.get<ApiResponse<Sender>>('/customer-portal/v2/sender-details', { signal }),
  );
}
